import { render, staticRenderFns } from "./feesInteractive.vue?vue&type=template&id=2e6ff4c6&scoped=true"
import script from "./feesInteractive.vue?vue&type=script&lang=js"
export * from "./feesInteractive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6ff4c6",
  null
  
)

export default component.exports